import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Pipeline } from '../types/pipelines';
import { apiFetch } from '../services/api';
import GA4SessionizationForm from './forms/GA4SessionizationForm';
import GA4FlattenerForm from './forms/GA4FlattenerForm';
import MarketingAttributionForm from './forms/MarketingAttributionForm';
import GoogleAdsCostLoaderForm from './forms/GoogleAdsCostLoaderForm';

const PipelineConfiguration: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [pipelineType, setPipelineType] = useState<Pipeline['type'] | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (id) {
            loadPipeline(id);
        }
    }, [id]);

    const loadPipeline = async (pipelineId: string) => {
        try {
            setLoading(true);
            const res = await apiFetch(`/api/pipelines/${pipelineId}`);
            if (res.ok) {
                const pipeline: Pipeline = await res.json();
                setPipelineType(pipeline.type);
            } else {
                setError('Failed to load pipeline');
            }
        } catch (error) {
            console.error('Failed to load pipeline:', error);
            setError('Failed to load pipeline');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="pipeline-configuration">
                <div className="header">
                    <h2>Edit Pipeline</h2>
                </div>
                <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
            </div>
        );
    }

    if (error) {
    return (
        <div className="pipeline-configuration">
            <div className="header">
                    <h2>Edit Pipeline</h2>
            </div>
                <div style={{ padding: '20px', color: 'red' }}>{error}</div>
                    </div>
        );
    }

    if (!pipelineType) {
        return <Navigate to="/pipelines" replace />;
    }

    // Render the appropriate form component based on pipeline type
    switch (pipelineType) {
        case 'ga4-sessionization':
            return <GA4SessionizationForm />;
        case 'ga4-flattener':
            return <GA4FlattenerForm />;
        case 'marketing-attribution':
            return <MarketingAttributionForm />;
        case 'google-ads-cost-loader':
            return <GoogleAdsCostLoaderForm />;
        default:
            return <Navigate to="/pipelines" replace />;
    }
};

export default PipelineConfiguration;
